module.exports = __webpack_public_path__ + "img/ohm-url.44350245.png";